import { render, staticRenderFns } from "./Lance.vue?vue&type=template&id=b945c32c&scoped=true"
import script from "./Lance.vue?vue&type=script&lang=js"
export * from "./Lance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b945c32c",
  null
  
)

export default component.exports